import SafeLayout from "./mySafe";

export default function Mypage(){
    return (
        <div className="modal-mypage-layout">
            <SafeLayout />
        </div>
    )
}